


import {
  defineComponent,
  PropType,
  ref,
} from '@vue/composition-api';

type TimeChangeEvent = { index: number; value: string };

export default defineComponent({
  props: {
    selectedIndex: {
      type: Number,
      default: 0,
    },
    timeLabels: {
      type: Array as PropType<string[]>,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 4,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  emits: ['change'],

  setup(props, { emit }) {
    const currentIndex = ref<number>(props.selectedIndex);

    const getLabelStyle = (index: number) : Record<string, string> => {
      if (props.timeLabels.length <= 1) return {};

      const percent = (index / (props.timeLabels.length - 1)) * 100;
      return { left: `${percent}%`, top: 'auto', transform: 'translateX(-50%)' };
    };
    const changeTo = (index: number): void => {
      const timeLabelsLength = props.timeLabels.length;
      if (index < 0 || index >= timeLabelsLength) return;

      if (currentIndex.value !== index) {
        currentIndex.value = index;
      }
      const payload: TimeChangeEvent = { index: index, value: props.timeLabels[index] };
      emit('change', payload);
    };
    const onSliderChange = (event: { target: { value: string } }): void => {
      const idx = Number(event.target?.value);
      changeTo(Number.isNaN(idx) ? 0 : idx);
    };
    const onLabelClick = (index: number): void => {
      changeTo(index);
    };

    return {
      currentIndex,
      getLabelStyle,
      onSliderChange,
      onLabelClick,
    };
  },
});
